import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37d5c03e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "china-map-container f1" }
const _hoisted_2 = { class: "map-title" }
const _hoisted_3 = { class: "fs16 color-06 bold" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("工单/客服地区分布图")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs12 color-02",
  style: {"margin-top":"8px"}
}, "点击地图上的省份可以查看省份城市的工单数量", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "ticket-china-map",
  style: {"width":"100%","height":"100%"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.currentProvince)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "return color-primary fs12",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToChina && _ctx.returnToChina(...args)))
            }, "返回"))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5
    ]),
    _hoisted_6
  ]))
}